import DIApi from './_diApi';

class JusticeCaseAPI extends DIApi {
  controllerName = 'JusticeCases';
}

export default new JusticeCaseAPI();
